import FullScreenContainerV2 from '@/components/layout/modals/FullScreenContainerV2';
import { useAnimation } from '@/hooks';
import { useTranslation } from 'next-i18next';
import { ANIMATION } from '@/constants/animation';
import { ModalHeaderDsProps } from '@/components/layout/modals/ModalHeader.ds';
import { useScreenSizeContext } from '@/components/ScreenSize.context';

import styles from '@/components/virtual-assistant/beta-assistant-modal.module.scss';
import CenteredModal from '@/components/layout/modals/CenteredModal';
import React from 'react';

export const BetaAssistantModal = ({ isOpen, closeModal }) => {
  const { animationState: animation, handleCloseModal } = useAnimation();
  const isMobile = useScreenSizeContext().isMobile;
  const { t } = useTranslation();

  const onClose = () => {
    handleCloseModal();
    setTimeout(closeModal, ANIMATION.DELAY_MODAL);
  };

  const header = {
    whichButton: 'closeButton',
    onCloseClick: onClose,
    title: t('assistant.beta.title'),
    size: 'small',
  } satisfies ModalHeaderDsProps;

  const modalContent = (
    <>
      {t('assistant.beta.content')}
      {/* <br />*/}
      {/* <a href="/virtual-assistant-faq.html" target="_blank" className={styles.link} rel="noopener noreferrer">*/}
      {/*  {t('assistant.beta.moreInformation')}*/}
      {/* </a>*/}
    </>
  );

  return isMobile ? (
    <FullScreenContainerV2
      padding="none"
      onClose={onClose}
      overlay
      isOpen={isOpen}
      designSystemHeader={header}
      animationClass={animation}
      classNames={{
        overlay: styles.overlay,
        container: styles.container,
        content: styles.content,
      }}
    >
      {modalContent}
    </FullScreenContainerV2>
  ) : (
    <CenteredModal
      opened={isOpen}
      title={t('assistant.beta.title')}
      cancelAction={closeModal}
      customContent={modalContent}
      fullWidth={isMobile}
    />
  );
};

export default BetaAssistantModal;
